/** Where is the CRM running? (website, installed PWA, or the Android app) */
export const ANDROID_RELEASES = "/downloads/android";

export const isNativeApp = () => typeof window !== "undefined" && !!window.TravnokNative;

export const isStandalonePWA = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true);

export const isAndroidDevice = () => /android/i.test(navigator.userAgent || "");
export const isIOSDevice = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent || "") ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

/** Installed Android app version, or null on the web. */
export const nativeAppInfo = () => {
  try {
    return isNativeApp() ? JSON.parse(window.TravnokNative.getAppInfo()) : null;
  } catch {
    return null;
  }
};

/**
 * The published Android release (written by scripts/release-android.sh).
 * Throws if no genuine release is published, so callers never show a dead link.
 */
export const fetchLatestAndroidRelease = async () => {
  const res = await fetch(`${ANDROID_RELEASES}/latest.json`, { cache: "no-store" });
  if (!res.ok) throw new Error(`No Android release (${res.status})`);
  const r = await res.json();
  const valid =
    Number.isInteger(r.versionCode) && r.versionCode > 0 &&
    typeof r.versionName === "string" &&
    typeof r.file === "string" && /^[\w.-]+\.apk$/.test(r.file) &&
    /^[0-9a-f]{64}$/i.test(r.sha256 || "");
  if (!valid) throw new Error("Invalid Android release manifest");
  return { ...r, url: `${ANDROID_RELEASES}/${r.file}`, latestUrl: `${ANDROID_RELEASES}/travnok-crm.apk` };
};

export const formatBytes = (n) => (n > 0 ? `${(n / (1024 * 1024)).toFixed(1)} MB` : "");
